
import React, { useRef, useEffect } from "react";
import {
  AvField
} from "availity-reactstrap-validation";
import Select from "react-select";
import CustomSelect from "./CustomSelect";
import { useTranslation } from "react-i18next";

function AvFieldSelecvt(props) {
  const {
    disabled = false,
  } = props;
  const ref1 = useRef();
  const { t } = useTranslation();
  const [state, setState] = React.useState(null);
  const onFieldChange = (e) => {
    if (props.isMulti){
      setState(e);
    } else {
      setState(e.value);
      if (props.onChange) {
        props.onChange(e.value);
      }
    }
  };
  // useEffect(() => {
  //   if (props.value === undefined) {
  //     ref1.current.state.value = undefined;
  //   }
  // }, [props.value]);
  const { label, ...params } = props;
  let options = props.options || [];
  let placeholder = props.placeholder || t("Select...");
  return (<React.Fragment>
    <label>{label}</label>
    <CustomSelect
      ref={ref1}
      placeholder={placeholder}
      options={options}
      isOptionDisabled={(option) => option.disabled}
      onChange={onFieldChange}
      isMulti={props.isMulti}
      maxMenuHeight={props.maxHeight}
      isDisabled={disabled}
    />
    <AvField
      {...params}
      type="select"
      value={state === null ? props.value : state}
      style={{
        opacity: 0,
        height: 0,
        margin: -10,
        "pointerEvents": "none",
      }}
    >
      {options.map((obj, index) => {
        return (<option key={index} value={obj.value}>{obj.label}</option>);
      })}
    </AvField>
    

  </React.Fragment>);
}

export default AvFieldSelecvt;
